/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosCarousel, CosmosCarouselProps } from "@components/elements";

export type CardCarouselProps = CosmosCarouselProps;

export const CardCarousel = ({ ...props }: CardCarouselProps): React.JSX.Element => {
	return <CosmosCarousel bleed="2rem" buttonPosition="outside" loop={false} {...props} />;
};
